import { Paper } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

export default function QuotaSubmissionStatusChart() {
  const state = useSelector((state) => state.dashboard);
  const { quotaSubmissionStatusDataPrepared, drawerOpen } = state;
  const { countries, statuses } = quotaSubmissionStatusDataPrepared;

  function getSeries() {
    let series = [];
    let group = "";
    for (let prop in statuses) {
      if (prop == "Active Scenarios") group = "MainTab";
      else group = "SubTab";
      const obj = {
        name: prop,
        group: group,
        data: statuses[prop],
      };
      series.push(obj);
    }
    return series;
  }
  const series = getSeries();

  const desiredOrder = ['Active Scenarios', 'Quota Approved', 'Quota Rejected','Quota Pending for Submission','Quotas Pending for Approval'];

  const orderedSeries = desiredOrder.map(name =>
    series.find(series => series.name === name)
  ).filter(series => series !== undefined);
  

  // const orderedSeries = [
  //   series.find(s => s.name === 'Active Scenarios'),
  //   series.find(s => s.name === 'Quota Approved'),    
  //   series.find(s => s.name === 'Quota Rejected'),
  //   series.find(s => s.name === 'Quota Pending for Submission'),
  //   series.find(s => s.name === 'Quotas Pending for Approval'),
  // ];
  


  const options = {
    chart: {
      type: "mixed",
      height: 100 + countries?.length * 10,
      stacked: true,
    },
     colors: ['#008FFB', '#00E396','#ff4560', '#FEB019','#775dd0'],
    title: {
      text: "Quota Submission Status",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: 1 * Math.log(countries?.length + 1) * 30 + "%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: countries ? [...countries] : [],
    },
  };

  return (
    <Paper elevation={2}>
      <Chart
        options={options}
        //series={series}
        series={orderedSeries}
        type="bar"
        width={drawerOpen ? "100%" : "100%"}
        height={drawerOpen ? "500" : "550"}
      />
    </Paper>
  );
}
